<script>
import CalendarReservationPreview from "@/components/Calendars/CalendarReservationPreview.vue";
import {mapGetters} from "vuex";
import RegularReservationModal from "@/views/pages/project/work_reserves/modals/RegularReservationModal";
import router from "@/mixins/router";
import DatePicker from "vue2-datepicker";
import constant from "@/configs/constant";
import datetime from "@/mixins/datetime";
const REGULAR_RESERVATION = "regular_reservation";
const RESERVATION_DATES = "reservation_dates";

export default {
  components: {
    CalendarReservationPreview,
    RegularReservationModal,
    DatePicker
  },
  mixins: [router,datetime],
  props: ["work_reservation"],
  data() {
    return {
      isLoading: true,
      scheduleType: {
        "reservation_dates": RESERVATION_DATES,
        "regular_reservation": REGULAR_RESERVATION
      },
      key_render_calendar: 1,
      calendarDuration: 0,
    };
  },
  created() {
  },
  methods: {
    refreshCalendar(start_date, end_date) {
      if (this.$refs.calendar) {
          this.$refs.calendar.getData(
          false,
          start_date,
          end_date
        )
      }
    },
    reRenderCalendar() {
      this.key_render_calendar++;
      this.calendarDuration = 0;
    },
    gotoPrev() {
      this.handleCalendarApi(-2);
    },
    gotoNext() {
      this.handleCalendarApi(2);
    },
    handleCalendarApi(duration) {
      const calendar_from_month = this.$refs.calendar_from_month.getCalendarApi();
      const calendar_to_month = this.$refs.calendar_to_month.getCalendarApi();
      this.calendarDuration += duration;

      calendar_from_month.gotoDate(this.getDateTimeFormat(0, 'YYYY-MM-DD'));
      calendar_to_month.gotoDate(this.getDateTimeFormat(1, 'YYYY-MM-DD'));
    },
    getDateTimeFormat(duration, format = 'YYYY-MM-DD')
    {
      return this.addOrSubtractTimeFromDate(parseInt(this.calendarDuration)+duration, 'months', 'add', this.getToday(), format);
    }
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    selectScheduleType() {
      return [
        {
          text: "予約日選択で指定",
          value: RESERVATION_DATES
        },
        {
          text: "定期予約指定",
          value: REGULAR_RESERVATION
        }
      ];
    },
    days_of_the_week() {
      return constant.DAY_OF_WEEKS;
    },
    displayRegularlyReservation() {
      return this.work_reservation.schedule_type === this.scheduleType.regular_reservation;
    },
    displayCalendarReservationDates() {
      return this.work_reservation.schedule_type === this.scheduleType.reservation_dates;
    },
    fromYearMonthLabel() {
      return this.getDateTimeFormat(0, 'YYYY年MM月');
    },
    toYearMonthLabel() {
      return this.getDateTimeFormat(1, 'YYYY年MM月');
    }
  },
  watch: {
    'work_reservation.reservation_dates_by_work_reservation': {
      handler: function (val) {
        this.reRenderCalendar();
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>
<template>
  <div class="mr-2 calender-info"
       v-if="work_reservation.reservation_dates_by_work_reservation.length || work_reservation.zz_regularly_reservation_interval_id">
    <b-row class="mt-4">
      <b-col class="d-flex align-items-center area-disable">
        <div class="custom-radio-group">
          <div class="radio-group">
            <b-form-radio
                          :value="selectScheduleType[0].value" v-model="work_reservation.schedule_type">
              {{ selectScheduleType[0].text }}
            </b-form-radio>
            <b-form-radio
                          :value="selectScheduleType[1].value" v-model="work_reservation.schedule_type">
              {{ selectScheduleType[1].text }}
            </b-form-radio>
          </div>
        </div>
      </b-col>
      <div class="calendar_month_preview" v-if="displayCalendarReservationDates">
        <div class="mt-2 bold">
          登録した予約日
        </div>
        <div class="text-center d-flex align-items-center justify-content-center gap-3">
          <div class="text-center">
            <b-col></b-col>
            <b-button variant="dark" @click="gotoPrev()"><b-icon-chevron-left variant="white"/></b-button>
            <span class="calendar-datetime-title">{{ fromYearMonthLabel }} - {{ toYearMonthLabel }}</span>
            <b-button variant="dark" @click="gotoNext()"><b-icon-chevron-right variant="white"/></b-button>
          </div>
        </div>
        <b-row style="margin-top: 10px;">
          <b-col>
            <CalendarReservationPreview
              ref="calendar_from_month"
              :events="work_reservation.reservation_dates_by_work_reservation"
              :start_date="work_reservation.regularly_reservation_start_date"
              :end_date="work_reservation.regularly_reservation_end_date"
              :key="`key_calendar_${key_render_calendar}`"
              duration="0"
              class="reserve_info_calendar_current_month setting_admin_calendar_display_month"
              :className="'reserve_info_calendar_current_month'"
            />
          </b-col>
          <b-col>
            <CalendarReservationPreview
              ref="calendar_to_month"
              :events="work_reservation.reservation_dates_by_work_reservation"
              :start_date="work_reservation.regularly_reservation_start_date"
              :end_date="work_reservation.regularly_reservation_end_date"
              :key="`key_calendar_${key_render_calendar}`"
              class="reserve_info_calendar_next_month setting_admin_calendar_display_month"
              :className="'reserve_info_calendar_next_month'"
              duration="1"
            />
          </b-col>
        </b-row>
      </div>
      <b-row class="mt-4 mb-4 area-disable" v-if="displayRegularlyReservation">
        <div class="mb-2 bold">
          定期予約の設定
        </div>
        <div>
          <b-row class="select-date">
            <b-col sm="1" class="d-flex align-items-center" for="start_date">開始年月日</b-col>
            <b-col sm="4">
              <div class="custom-datepicker gap-2">
                <div class="input-control">
                  <date-picker
                    v-model="work_reservation.regularly_reservation_start_date"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                  ></date-picker>
                </div>
              </div>
            </b-col>
            <b-col cols="1" class="split text-center">
              <span>～</span>
            </b-col>
            <b-col cols="4">
              <div class="custom-datepicker gap-2">
                <label for="end_date">終了年月日</label>
                <div class="input-control">
                  <date-picker
                    v-model="work_reservation.regularly_reservation_end_date"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                  ></date-picker>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col sm="1" class="d-flex align-items-center">
              <label class="col-form-label text-nowrap me-2" for="day_of_time_zone">時間帯</label>
            </b-col>
            <b-col sm="11" class="d-flex align-items-center">
              <div class="custom-radio-group">
                <div class="radio-group" style="margin-left: 0 !important;">
                  <b-form-radio
                    v-for="option in options_tables.zz_day_of_time_zones"
                    v-model="work_reservation.zz_day_of_time_zone_id"
                    :value="option.id"
                  >
                    {{ option.day_of_time_zone }}
                  </b-form-radio>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col sm="1" class="d-flex align-items-center">
              <label class="col-form-label text-nowrap me-2" for="regularly_reservation_interval_id">頻度</label>
            </b-col>
            <b-col sm="2" class="d-flex align-items-center">
              <div class="custom-radio-group">
                <div class="radio-group" style="margin-left: 0 !important;">
                  <b-form-radio
                    v-for="option in options_tables.zz_regularly_reservation_intervals"
                    :value="option.id"
                    v-model="work_reservation.zz_regularly_reservation_interval_id"
                    disabled-field="notEnabled"
                  >
                    {{ option.regularly_reservation_interval }}
                  </b-form-radio>
                </div>
              </div>
            </b-col>
            <b-col cols="2">
              <div class="input-control">
                <div class="custom-input number-of-date gap-2">
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <div class="input-control">
                      <b-form-input
                        type="number"
                        class="d-flex gap-3"
                        v-model="work_reservation.regularly_reservation_date_of_month"
                        name="number-of-date"
                        :aria-describedby="ariaDescribedby"
                      >
                      </b-form-input>
                    </div>
                  </b-form-group>
                  <div class="align-self-center">日</div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col sm="1" class="d-flex align-items-center">
              <label class="col-form-label text-nowrap me-2"></label>
            </b-col>
            <b-col sm="4" class="d-flex align-items-center">
              <div class="custom-radio-group" style="margin-left: 0 !important;">
                  <b-form-checkbox-group
                    id="checkbox-group-days-of-the-week-disabled"
                    class="radio-group checkbox-group-days-of-the-week-disabled"
                    v-model="work_reservation.regularly_reservation_day_of_week"
                    :options="days_of_the_week"
                    name="checkbox-group-days-of-the-week-disabled"
                  ></b-form-checkbox-group>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-row>
    </b-row>
  </div>
</template>
<style lang="scss">
.select-date {
  .split {
    font-size: 25px;
  }
}

.custom-datepicker label {
  align-self: unset;
}

.input-control.invalid span {
  white-space: nowrap;
}

.mr-5 {
  margin-right: 5px;
}

.calender-info {
  .area-disable, .fc-view-harness {
    pointer-events: none;
  }

  .bold {
    font-weight: 600;
  }

  #calendar-type {
    margin-left: 0 !important;
  }

  #checkbox-group-days-of-the-week {
    margin-left: 55px;
  }
}

.checkbox-group-days-of-the-week-disabled {
  margin-left: 0 !important;
}

.calendar-datetime-title {
  margin-left: 10px;
  margin-right: 10px;
  font-weight: bold;
}
</style>
